import {
  ADD_MARKET_PRODUCTS,
  FETCH_MARKET_BANNERS,
  SET_MARKETS_SELECTED_TAB,
} from 'actionTypes/markets';
import { MARKET_BANNERS, MARKET_SPOT_INDICES } from 'constants/api';
import createAction from 'helpers/createAction';

export const addMarketProducts = createAction(ADD_MARKET_PRODUCTS);

const setMarketsSelectedTab = createAction<string>(SET_MARKETS_SELECTED_TAB);

const fetchMarketBanners = () => {
  return {
    types: FETCH_MARKET_BANNERS,
    promise: ({ request }) => request.get(MARKET_BANNERS),
  };
};

enum TopSpotIndicesOptions {
  TOP_GAINERS = 'top_gainers',
  TOP_LOSERS = 'top_losers',
}

function getTopSpotIndices(
  sortBy: TopSpotIndicesOptions = TopSpotIndicesOptions.TOP_GAINERS,
  limit: number = 8,
  page: number = 1
) {
  return {
    promise: ({ request }) =>
      request.get(MARKET_SPOT_INDICES, { params: { sort_by: sortBy, limit, page } }),
  };
}

export { getTopSpotIndices, setMarketsSelectedTab, fetchMarketBanners };
